<main [dir]="direction" [class]="translate.currentLang">
	<router-outlet></router-outlet>
</main>
